import React from "react";
import { SystemActivityStatistics } from "../statistics/system-activity-statistics/system-activity-statistics";

const ProductionStatisticsPage: React.FC = () => {
	return <SystemActivityStatistics />;
};

export default ProductionStatisticsPage;
